import { executeRequest, Request } from '@jfs/network'
import { downloadReportsListParser } from '../network/parsers/DownloadReportsListParser'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const responseParser = (data: any, pageNum: number) => {
  return downloadReportsListParser(data, pageNum)
}

const getInputFilterByType = (
  type: string,
  mid: string,
  _startDateTime: string,
  _endDateTime: string,
  isSmid: boolean,
) => {
  return type === 'VAULT'
    ? {
        responseType: 'DEFAULT',
        transactionType: type,
        merchantId: mid,
        isSMID: isSmid ? 'Y' : 'N',
        // startDateTime: startDateTime,
        // endDateTime: endDateTime,
      }
    : {
        responseType: 'CUSTOM',
        transactionType: type,
        merchantId: mid,
        isSMID: isSmid ? 'Y' : 'N',
        // startDateTime: startDateTime,
        // endDateTime: endDateTime,
      }
}
const getPageObjectByType = (type: string, pageNum: any) => {
  return type === 'SETTLEMENT'
    ? {
        page: pageNum,
        size: 10,
        mediaType: 'XLSX',
        sortType: 'DESC',
      }
    : { page: pageNum, recordCount: 10, mediaType: 'XLSX', sortType: 'DESC' }
}
const getTxnsRefundsDownloadListReq = async (
  tokens: any,
  mid: string,
  _startDateTime: string,
  _endDateTime: string,
  transactionType: string,
  pageNum: number,
  isSmid: boolean,
) => {
  const request: Request<{}> = {
    apiPath:
      transactionType === 'SETTLEMENT'
        ? APIEndPoints.getSettlementsDownloadList
        : APIEndPoints.getTxnsRefundsDownloadList,
    method: 'POST',
    config: sitConfig(tokens),
    body: {
      inputFilter: getInputFilterByType(transactionType, mid, _startDateTime, _endDateTime, isSmid),
      configParams: getPageObjectByType(transactionType, pageNum),
      outputDomains:
        transactionType !== 'VAULT'
          ? [
              'transactionDateTime',
              'invoice',
              'transactionId',
              'transactionAmount',
              'transactionDisposition',
              'cardType',
              'paymentType',
              'issRefData',
            ]
          : undefined,
      localId: 'downloadsList', //TODO:used for mocks body identifier regex
    },
  }
  const data = await executeRequest(request)
  return responseParser(data.data, pageNum)
}

export { getTxnsRefundsDownloadListReq }
